<template>
	<div class="details">
		<div class="head">
			<p class="flex between">
				<span class="title text-ellipsis">{{planInfo.title}}</span>
			</p>
			<p class="row2 flex between">
				<span>
					<span class="teacher">{{planInfo.teacherName}}</span>{{planInfo.createTime}}
				</span>
				<span></span>
			</p>
		</div>
		<div class="rich-text">
			<div v-html="planInfo.content"></div>
		</div>
    <div style="height: 200px;margin-top: 40px;">
      <video style="height: 200px;width: 100%;" controls :src="planInfo.videoUrl"></video>
    </div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			planInfo: {},
		};
	},
	mounted() {
		this.getPlanInfo();
	},
	methods: {
		async getPlanInfo() {
			let params = {};
			params.previewId = this.$route.query.planId;
			try {
				let {success,message,result} = await this.$http.get("h5/preview/getPreviewInfo",{params:params})
				if (!success) throw new Error(message);
				this.planInfo = result;
			} catch (error) {
				console.error("getPlanInfo", error?.message);
			}
		},
	},
};
</script>


<style lang="less" scoped>
.details {
	height: 100%;
	padding: 17 / @rem;
	.head {
		button {
			width: 48 / @rem;
			height: 19 / @rem;
			font-size: 11 / @rem;
			color: rgba(255, 162, 22, 1);
			border: 1 / @rem solid rgba(255, 162, 22, 1);
			border-radius: 10 / @rem;
			background-color: white;
		}
		span {
			&.title {
				flex: 1;
				font-size: 19 / @rem;
				font-family: SourceHanSansCN-Medium-, SourceHanSansCN-Medium;
			}
		}
		.row2 {
			padding: 9 / @rem 0 21 / @rem;
			font-size: 10 / @rem;
			color: rgba(31, 30, 29, 0.3);
			.teacher {
				color: rgba(255, 162, 22, 1);
				padding-right: 10 / @rem;
			}
		}
	}

	.rich-text {
		overflow-y: scroll;
		/deep/img,video {
			width: 100%;
			object-fit: contain;
		}
	}
}
</style>
